import React from 'react';

interface Props {
  svg: any;
  fillColor?: string;
  className?: string;
}

const CustomSVGs = ({ svg, fillColor, className }: Props) => {
  const propsToAdd: any = {};

  if (fillColor) propsToAdd.fill = fillColor;
  if (className) propsToAdd.className = className;

  return React.cloneElement(svg, propsToAdd);
};

export default CustomSVGs;
